import { Loader, Upload } from "lucide-react";

import { Button } from "@/components/ui/button";
import { showNotification } from "components/notification";
import { useEffect } from "react";
import { usePublishMap } from "./hooks/paginated-cities.hook";

export const PublishMapComponent = () => {
  const { publishMap, loading, data } = usePublishMap();

  useEffect(() => {
    if (data?.publishCitiesTiles) {
      showNotification({
        variant: "success",
        message: "Map published successfully",
      });
    }
  }, [data]);

  return (
    <Button onClick={() => publishMap()} className="gap-x-1" disabled={loading} variant="outline">
      Publish map
      {loading ? <Loader className="size-4 animate-spin" /> : <Upload className="size-4" />}
    </Button>
  );
};
